import { MapPinned } from "lucide-react";
import { useConsent } from "@/context/ConsentContext";

export default function MapConsent({ query, title = "Karte" }) {
  const { consent, acceptExternalMedia } = useConsent();
  const embedUrl = `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;

  if (consent?.externalMedia) {
    return (
      <div className="relative aspect-[4/3] w-full overflow-hidden rounded-xl border border-[#27272A] sm:aspect-[16/9]" data-testid="map-embed">
        <iframe
          title={`Google Maps – ${title}`}
          src={embedUrl}
          loading="lazy"
          className="absolute inset-0 h-full w-full border-0"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    );
  }

  return (
    <div
      className="flex aspect-[4/3] w-full flex-col items-center justify-center gap-4 rounded-xl border border-dashed border-[#27272A] bg-[#16161A] p-6 text-center sm:aspect-[16/9]"
      data-testid="map-consent-placeholder"
    >
      <MapPinned className="h-10 w-10 text-[#F54855]" aria-hidden="true" />
      <div>
        <p className="font-display text-lg font-semibold text-[#F5F5F3]">Google Maps ist deaktiviert</p>
        <p className="mx-auto mt-1 max-w-md text-sm leading-relaxed text-[#A1A1AA]">
          Aus Datenschutzgründen wird die Karte erst nach deiner Zustimmung geladen. Beim Laden
          werden Daten an Google übertragen.
        </p>
      </div>
      <button
        type="button"
        onClick={acceptExternalMedia}
        className="inline-flex min-h-[44px] items-center rounded-lg bg-[#E11D2A] px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#F02837]"
        data-testid="maps-load-button"
      >
        Google Maps laden
      </button>
    </div>
  );
}
